// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"02e81fe1","394":"f4d4dbf0","400":"21327594","422":"c0076dcf","453":"aac68abc","615":"0bc1efe5","781":"334bdd02"}[chunkId] + ".chunk.js";
};